<div style="padding: 3px;overflow: hidden;">
  <span class="edit-user-photo-dialog-header">
    <h2 mat-dialog-title>Edit Profile Photo</h2>
    <button mat-icon-button matTooltip="Close" id="btnBadge" class="inverse-button-no-border" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </span>


  <div class="edit-user-photo-dialog-body">
    <div class="edit-user-photo-container">
      @if (currentImage) {
        <img class="edit-user-profile-photo" src="{{currentImage}}"
          alt="User Photo">
      } @else {
        <img src="assets/images/logo_and_icons/empty_portrait_white_large.png" class="edit-user-profile-photo"
          alt="Empty Picture">
        }
      </div>
      <div class="edit-user-photo-dialog-body">
        <label id="lblerror" class="error-message"> {{errorMessage}} <a [href]="serviceUrl" target="_blank">{{clickhere}}</a></label>

        @if (progressBar) {
          <mat-spinner></mat-spinner>
        }
      </div>
      <span class="edit-user-photo-mobile-container">
        <button mat-button class="regular-button"   id="btnBadge" (click)="onGetIDMSImageFromBadgingOffice()">
          <mat-icon>badge</mat-icon>
          Badging Office Image
        </button>

        <button mat-button class="regular-button"  id="btnBrowse" (click)="imageFileUpload.click()">Browse Image</button>
        <input #imageFileUpload type='file' (change)="onImageSelect($event)" accept="image/*"
          style="display: none;">

        </span>
        <span class="edit-user-photo-mobile-container">
          <button mat-button class="regular-button" (click)="CancelSave()" id="btnCancel">
            Cancel
          </button>

          <button mat-button [disabled]="disableUpdate" id="btnUpdate" class="regular-button done" (click)="SaveImage()">
            Update
          </button>
        </span>
      </div>


      @if (BrowsedPhoto) {
        <h3><strong class="info-message">Photo Result: {{infoMessage}} </strong></h3>
        <div class="edit-user-photo-dialog-body">
          <div class="edit-user-photo-container">
            <img id="uploadedPhoto" class="edit-user-profile-photo" [src]="BrowsedPhoto" alt="Uploaded Photo">
          </div>
        </div>
      }
    </div>

